var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',[_c('el-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],attrs:{"shadow":"never"}},[_vm._v("\n      user profile page\n    ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }